module.exports = __webpack_public_path__ + "static/banner_2-dff2c4576a1ab5d5042fe917d88f78fc.png";